/** Category options for a ProgramDocument, shared by the Docs tab and the Companies tab. */ export const DOCUMENT_CATEGORY_OPTIONS = [
    {
        value: 'PMR',
        label: 'PMR'
    },
    {
        value: 'TPP',
        label: 'TPP'
    },
    {
        value: 'Decision Log',
        label: 'Decision Log'
    },
    {
        value: 'Kickoff',
        label: 'Kickoff'
    },
    {
        value: 'Contract',
        label: 'Contract'
    },
    {
        value: 'Subcontract',
        label: 'Subcontract'
    },
    {
        value: 'Closeout',
        label: 'Closeout'
    },
    {
        value: 'Other',
        label: 'Other'
    }
];
/** The category value that routes a document into the contract re-extraction lane. */ export const CONTRACT_DOCUMENT_CATEGORY = 'Contract';
// A document attached from the Companies tab is, by default, that company's
// subcontract paperwork - the most common reason to attach a file here.
export const DEFAULT_COMPANY_DOCUMENT_CATEGORY = 'Subcontract';
